import { useInsiderState } from "./useInsiderState";

export const useShowEligibleInsiderMessaging = () => {
  const { isInsiderEligible, isInsiderCancelled } = useInsiderState();
  const showEligibleInsiderMessaging = isInsiderEligible || isInsiderCancelled;

  return { showEligibleInsiderMessaging };
};
